var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-track-container"},[_c('BMap',{ref:"bmap",on:{"loaded":_vm.bmapLoaded}}),_c('div',{staticClass:"data-panel-layer"},[(_vm.sensors.length)?_c('SensorData'):_vm._e(),_c('AlarmTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }